import { render } from "./CompanyConfiguration.vue?vue&type=template&id=ff0a2824&scoped=true"
import script from "./CompanyConfiguration.vue?vue&type=script&lang=js"
export * from "./CompanyConfiguration.vue?vue&type=script&lang=js"

import "./CompanyConfiguration.vue?vue&type=style&index=0&id=ff0a2824&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff0a2824"]])

export default __exports__
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTabs,QTab,QTabPanels,QTabPanel});
